export default __webpack_public_path__ + "static/soehne-web-buch-46a55e04c72229c19cdac4c5e378dbd3.woff";